import "./GutterInstallation.module.css";
import Header from "@/reusable_sections/Header";
import RemplacementUrethanPortePatioMontreal from "./sections/RemplacementUrethanPortePatioMontreal";
import ServiceDetailsInstallationProcess from "./sections/ServiceDetailsInstallationProcess";
import Footer from "@/reusable_sections/Footer";
export default function GutterInstallationPage() {
  return <div>
      <Header />
      <RemplacementUrethanPortePatioMontreal />
      <ServiceDetailsInstallationProcess />
      <Footer />
    </div>;
}